import { render, staticRenderFns } from "./PaymentModal.vue?vue&type=template&id=9de351de&"
import script from "./PaymentModal.vue?vue&type=script&lang=js&"
export * from "./PaymentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9de351de')) {
      api.createRecord('9de351de', component.options)
    } else {
      api.reload('9de351de', component.options)
    }
    module.hot.accept("./PaymentModal.vue?vue&type=template&id=9de351de&", function () {
      api.rerender('9de351de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/profile/PaymentModal.vue"
export default component.exports